import { render, staticRenderFns } from "./AudanetLockNotification.vue?vue&type=template&id=5c4c8cc3&scoped=true"
import script from "./AudanetLockNotification.vue?vue&type=script&lang=js"
export * from "./AudanetLockNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4c8cc3",
  null
  
)

export default component.exports